import api from 'base/utils/api';

/**
 * 获取翻译数据
 * @param codes
 * responseData = {
 *     en: {
 *         web_code: 'text'
 *     }
 * }
 */
export function getTranslation(codes: string[], compile = false): Promise<Record<string, Record<string, string>>> {
    return api.post('/web/pageCode/list/langCodes', {
        forceCamel: false,
        data: {
            langCodes: codes,
            compile
        }
    }).catch(err => {
        console.log('getTranslation error', err);
        return {}
    });
}